var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-row',[_c('organisation-list'),_c('tarifvertrag-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }